/**
 * Given a collection (generally a Ember.MutableArray), get a dictionary (map) indexed by the ember model ids.
 *
 * @param {Ember.MutableArray|Collection} modelCollection
 * @return {{}}   a dictionary (map) indexed by the ember model ids.
 */
export function getDictionaryForEmberCollection(modelCollection) {
  let dictionary = {};
  modelCollection.forEach(model => {
    dictionary[model.get('id')] = model;
  });

  return dictionary;
}

/**
 * Compare these two collections and return true if they have the same models and ids.
 *
 * NOTE - THIS WILL NOT DO A DEEP EQUAL.  Just compares to see if same models are present.
 *
 * @param {Ember.MutableArray|Collection} collectionA
 * @param {Ember.MutableArray|Collection} collectionB
 * @return {boolean}    True if locations are equal.
 */
export function areCollectionsEqual(collectionA, collectionB) {
  let haveCollectionsChanged = false;
  if (collectionA.get('length') !== collectionB.get('length')) {
    // these lengths are not the same, so can not be equal
    haveCollectionsChanged = true;
  } else {
    // we have collections with the SAME lengths, so to be the same, they must have all the same models.

    let collectionADictionary = getDictionaryForEmberCollection(collectionA);
    collectionB.find(modelB => {
      if (!collectionADictionary[modelB.id]) {
        // model id is not in the map, so we can set our flag, and return true which will stop this loop.

        haveCollectionsChanged = true;
        return true;
      }
    });
  }

  return !haveCollectionsChanged;
}
